
    var mustache = require('mustache');
    module.exports = function (view, partials) {
      partials = partials || {};
      var src = "{{#displayName}}\n  <h1 class=\"card-header\">{{displayName}}</h1>\n  <h2 class=\"card-subheader\">{{email}}</h2>\n{{/displayName}}\n{{^displayName}}\n  <h1 class=\"card-header\">{{email}}</h1>\n  <h2 class=\"card-subheader\"></h2>\n{{/displayName}}\n"
      return mustache.render(src, view, partials);
    };
  